import React from "react";
import LazyloadImage from "./LazyloadImage";
import StaticImage from "./StaticImage";

export default class DesignerCardImage extends React.Component {
  static defaultProps = {
    containerClassName: 'designer-card-image-container',
    desktopWidth: 294,
    desktopHeight: 272,
    mobileWidth: 94,
    mobileHeight: 87,
    mdCrop: 'rs_588.544',
    smCrop: 'rs_188.174',
    show_spinner: false
  };

  render() {
    let { isLeadImage, isMobile } = this.props;

    return (
      isLeadImage && isMobile ? <StaticImage {...this.props} /> : <LazyloadImage {...this.props} />
    )
  }
}
